@let assets = assets$ | async;
<div class="add-container" [hideIfNotAllowed]="createPerms">
  <button mat-stroked-button type="button" color="primary" (click)="onAdd()">
    <mat-icon>add_circle</mat-icon>
    {{ 'add' | i18nextCap }}
  </button>
</div>
@if (assets != null && assets.length === 0) {
  <p class="empty">{{ 'noCompanyAssets' | i18nextCap }}</p>
}
@for (a of assets; track a.id) {
  <mat-card class="asset-item">
    <div class="asset-item-left">
      <mat-icon>precision_manufacturing</mat-icon>
      <div class="details">
        <span class="title">
          {{ a.name }}
          @if (!a.active) {
            <span class="badge inactive">{{ 'inactive' | i18nextCap }}</span>
          }
        </span>
        @if (
          a.assetClass === 'STANDALONE_EQUIPMENT' &&
          a.classSpecificProperties.serialNumber
        ) {
          <span class="subtitle">{{
            a.classSpecificProperties.serialNumber
          }}</span>
        }
      </div>
    </div>
    <button
      mat-icon-button
      type="button"
      [attr.aria-label]="'openAsset' | i18nextCap"
      [matTooltip]="'openAsset' | i18nextCap"
      (click)="onOpen(a.id)"
    >
      <mat-icon>open_in_new</mat-icon>
    </button>
  </mat-card>
}
